const roomPageEvents = {
  action: "room-page",
  labels: {
    visit: (compositionId, sceneId) => `visit:${compositionId}-${sceneId}`,
    placeFurniture: (compositionId, sceneId) =>
      `place-furniture:${compositionId}-${sceneId}`,
    save: (compositionId, sceneId) => `save:${compositionId}-${sceneId}`,
    share: (compositionId, sceneId) => `share:${compositionId}-${sceneId}`,
  },
};

export default roomPageEvents;
